import { render, staticRenderFns } from "./Company2.vue?vue&type=template&id=46e4c50a"
import script from "./Company2.vue?vue&type=script&lang=js"
export * from "./Company2.vue?vue&type=script&lang=js"
import style0 from "./Company2.vue?vue&type=style&index=0&id=46e4c50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports